exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inventory-overview--container {\n  margin: 24px 0;\n}\n\n.inventory-generation-chart--header {\n  display: flex;\n  justify-content: space-between;\n}", ""]);

